import ErrorMessage from './ErrorMessage';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import useT from '@hooks/useT';

function NotFoundError() {
  const { t } = useT('errors');
  return (
    <ErrorMessage
      title={t('components.notFound.title')}
      message={t('components.notFound.message')}
      icon={<SearchOffIcon />}
      severity="warning"
    />
  );
}

export default NotFoundError;
